import { AutogenLayoutDispatchZone } from "./autogen/AutogenLayoutDispatchZone";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class DispatchZone extends AutogenLayoutDispatchZone {

    override onLoad(): void | Promise<void> {
        this.validateDispatchZoneRecordExist();
    }

    private validateDispatchZoneRecordExist() {
        const dispatchZoneUrl = "lme/dispatch/DispatchZone?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "zones", screenName: "DispatchZone", navigateToUrl: dispatchZoneUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

}
